interface Props {
  className?: string;
}

function pts(n: number, r: number, cx = 12, cy = 12, offsetDeg = -90) {
  return Array.from({ length: n }, (_, i) => {
    const a = ((i * 360) / n + offsetDeg) * (Math.PI / 180);
    return { cx: cx + r * Math.cos(a), cy: cy + r * Math.sin(a) };
  });
}

export function DrillBitIcon({ className }: Props) {
  const teeth   = pts(8, 10);   // 8 teeth around outer edge
  const inserts = pts(6, 3);    // 6 insert dots inside inner ring

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Gear teeth — solid filled circles */}
      {teeth.map((t, i) => (
        <circle key={i} cx={t.cx} cy={t.cy} r="1.8" fill="currentColor" stroke="none" />
      ))}

      {/* Main body ring */}
      <circle cx="12" cy="12" r="8.5" />

      {/* Inner ring */}
      <circle cx="12" cy="12" r="5" />

      {/* Insert dots — solid filled */}
      {inserts.map((p, i) => (
        <circle key={i} cx={p.cx} cy={p.cy} r="0.9" fill="currentColor" stroke="none" />
      ))}

      {/* Gauge / wrench slot */}
      <rect x="0.5" y="10.75" width="23" height="2.5" rx="1.25" />
    </svg>
  );
}
